<template>
<div class="table-chart">
    <div v-if="chartData.datasets && chartData.datasets.length === 0">No results found...</div>

    <table v-else>
        <tr>
            <th v-for="label in chartData.labels" :key="label">{{ label }}</th>
        </tr>

        <tr v-for="sessionInfo in chartData.datasets" :key="sessionInfo.sessionId">
            <td>{{ sessionInfo.sessionId }}</td>
            <td>{{ sessionInfo.meetings.totalCount }}</td>
            <td>{{ round(sessionInfo.publisherMinutes, 4) }}</td>
            <td>{{ round(sessionInfo.subscriberMinutes, 4) }}</td>
        </tr>
    </table>
</div>
</template>

<script>
export default {
    name: 'TableChart',
    props: {
        chartData: {
            type: Object,
            required: true
        },
        chartOptions: {
            type: Object
        }
    },
    methods: {
        round(value, decimals) {
            return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
        }
    }
}
</script>

<style scoped>
.table-chart {
    overflow: scroll;
}
</style>
